const URL = {
    BASE_URL: "https://api.ptskart.com/api/v1",
    BASE_URL_IMAGE: "https://api.ptskart.com/api/v1/uploads/products/"
}




export default URL